import { IVoiceCallTime } from "@interfaces/voicecall/voicecall";
import axiosApiInstance from "@services/custom-axios-instance";
import { generateUrl } from "@services/generateUrl/generateUrl";

export async function getVoiceCallStartData(callId: string): Promise<IVoiceCallTime> 
{
    const url = `${generateUrl()}/voice-call-server/time/${callId}`;
    const result = await axiosApiInstance.get<IVoiceCallTime>(url);
    return result.data;
}

export async function deleteVoiceCallStartData(callId: string): Promise<number> 
{
    const url = `${generateUrl()}/voice-call-server/time/${callId}`;
    const result = await axiosApiInstance.delete<IVoiceCallTime>(url);
    return result.status;
}
